import { PageNotAvailableContent } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

export type RouteApiErrorCode = "requires-admin";

export interface RouteErrorViewProps {
  code: RouteApiErrorCode;
}

export const RouteErrorView = ({ code }: RouteErrorViewProps) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <PageNotAvailableContent>
      <p>{formatMessage(`code.${code}`)}</p>
    </PageNotAvailableContent>
  );
};

const formatStrings = {
  "code.requires-admin": {
    en: "This page requires you to have an admin role in this workspace.",
  },
};
